import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import { Search, X } from "lucide-react";

const Books = () => {
  const navigate = useNavigate();

  const [books, setBooks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showMyShop, setShowMyShop] = useState(false);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Semua");

  const userStr = localStorage.getItem("erpUser");
  const userData = userStr ? JSON.parse(userStr) : null;
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const isAdmin = userData?.level === "admin";

  useEffect(() => {
    const fetchAllBooks = async () => {
      try {
        const res = await axios.get("https://api.kamulyaan.id/books");
        setBooks(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAllBooks();
  }, []);

  const filteredBooks = books.filter((book) => {
    const matchesSearch =
      (book.title || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (book.desc || "").toLowerCase().includes(searchTerm.toLowerCase());

    const matchesMyShop = showMyShop
      ? book.storeid && String(book.storeid) === String(userData?.userid)
      : true;

    const matchesCategory =
      selectedCategory === "Semua" ||
      (book.category || "").toLowerCase() === selectedCategory.toLowerCase();

    return matchesSearch && matchesMyShop && matchesCategory;
  });

  const handleDelete = async (id) => {
    if (!window.confirm("Hapus item ini?")) return;
    try {
      await axios.delete(`https://api.kamulyaan.id/books/${id}`);
      setBooks((prev) => prev.filter((b) => b.id !== id));
    } catch (err) {
      console.log(err);
      alert("Gagal menghapus item");
    }
  };

  // When "Beli" is clicked → go to Order page
  const handleBuy = (book) => {
    if (!isLoggedIn) {
      setShowAccessModal(true);
      return;
    }
    navigate(`/order/${book.id}`);
  };

  const checkAccess = (action) => {
    if (!isLoggedIn) {
      setShowAccessModal(true);
      return;
    }
    action();
  };

  return (
    <div className="app">
      <Header
        isSidebarOpen={isSidebarOpen}
        isRightSidebarOpen={isRightSidebarOpen}
        toggleSidebar={() => checkAccess(() => setIsSidebarOpen(!isSidebarOpen))}
        toggleRightSidebar={() => setIsRightSidebarOpen(!isRightSidebarOpen)}
        toggleMyShop={() => setShowMyShop(!showMyShop)}
        showMyShop={showMyShop}
        setShowAccessModal={setShowAccessModal}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />

      {/* ACCESS DENIED MODAL */}
      {showAccessModal && (
        <div className="modal-overlay">
          <div className="access-modal">
            <div className="modal-header">
              <X onClick={() => setShowAccessModal(false)} className="close-btn" />
            </div>
            <p>Silakan menghubungi pengurus untuk mendapatkan user id dan password</p>
            <button onClick={() => setShowAccessModal(false)} className="ok-btn">OK</button>
          </div>
        </div>
      )}

      <div className="search-section">
        <div className="search-box">
          <Search size={18} color="#888" />
          <input
            type="text"
            placeholder="Cari produk..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Current filter info */}
      {selectedCategory !== "Semua" && (
        <div
          style={{
            textAlign: "center",
            padding: "8px",
            background: "#f0f8ff",
            margin: "10px 20px",
            borderRadius: "8px",
            fontSize: "0.95rem",
          }}
        >
          Menampilkan kategori: <strong>{selectedCategory}</strong>
          <button
            onClick={() => setSelectedCategory("Semua")}
            style={{
              marginLeft: "10px",
              color: "#1976d2",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Tampilkan Semua
          </button>
        </div>
      )}

      <div className="books-container">
        {filteredBooks.length === 0 ? (
          <p
            style={{
              textAlign: "center",
              color: "#777",
              margin: "40px 20px",
              fontSize: "1.1rem",
            }}
          >
            Tidak ditemukan produk
            {selectedCategory !== "Semua" ? ` dalam kategori "${selectedCategory}"` : ""}
            {searchTerm ? ` dengan kata kunci "${searchTerm}"` : ""}
          </p>
        ) : (
          <div className="books">
            {filteredBooks.map((book) => {
              const hasWeb = Boolean(book.web && book.web.trim());
              const isOwner =
                isLoggedIn &&
                book.storeid != null &&
                String(book.storeid) === String(userData?.userid);
              const canSeeUpdateDelete = isAdmin || isOwner;

              return (
                <div key={book.id} className="book">
                  <div className="cover-container">
                    <img
                      src={book.cover || "https://placehold.co/300x300?text=Tanpa+Gambar"}
                      alt={book.title || "Produk"}
                      className={hasWeb && isLoggedIn ? "clickable-img" : ""}
                    />
                    <button className="buy-btn" onClick={() => handleBuy(book)}>
                      Beli
                    </button>
                  </div>

                  <div className="book-content">
                    <h1>{book.title || "Nama produk tidak tersedia"}</h1>
                    <p>{book.desc || "Tidak ada deskripsi"}</p>
                    <span>
                      Rp.{" "}
                      {book.price
                        ? Number(book.price).toLocaleString("id-ID")
                        : "Harga tidak tersedia"}
                    </span>

                    <div className="actions">
                      {canSeeUpdateDelete && (
                        <>
                          <button className="delete" onClick={() => handleDelete(book.id)}>
                            ❌
                          </button>
                          <button className="update">
                            <Link
                              to={`/update/${book.id}`}
                              state={{ book }}
                              style={{ color: "inherit", textDecoration: "none" }}
                            >
                              ✏️
                            </Link>
                          </button>
                        </>
                      )}

                      <Link to={`/detail/${book.id}`} className="detail-btn">
                        Lihat Detail
                      </Link>

                      {hasWeb && (
                        <button
                          className="more-info"
                          onClick={() =>
                            window.open(
                              book.web.startsWith("http") ? book.web : `https://${book.web}`,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                        >
                          🔗
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <style>{`
        .app { min-height: 100vh; background: #f9f9f9; }
        .modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 10000; display: flex; justify-content: center; align-items: center; }
        .access-modal { background: white; padding: 20px; border-radius: 12px; width: 85%; max-width: 320px; text-align: center; box-shadow: 0 10px 25px rgba(0,0,0,0.2); }
        .modal-header { display: flex; justify-content: flex-end; }
        .close-btn { cursor: pointer; color: #888; }
        .access-modal p { font-weight: 600; margin: 20px 0; color: #333; line-height: 1.5; }
        .ok-btn { background: #6bbe23; color: white; border: none; padding: 10px 30px; border-radius: 20px; font-weight: bold; cursor: pointer; width: 100%; }
        .search-section { display: flex; justify-content: center; padding: 10px 20px; }
        .search-box { display: flex; align-items: center; background: #fff; border: 1px solid #ddd; border-radius: 20px; padding: 8px 15px; width: 100%; max-width: 400px; box-shadow: 0 2px 5px rgba(0,0,0,0.05); }
        .search-box input { border: none; outline: none; margin-left: 10px; width: 100%; font-size: 1rem; }
        .books-container { padding: 0 20px 80px; max-width: 1400px; margin: 0 auto; }
        .books { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 30px; justify-content: center; }
        .book { border: 1px solid #eee; border-radius: 8px; overflow: hidden; background: #fff; display: flex; flex-direction: column; position: relative; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: transform 0.2s, box-shadow 0.2s; }
        .book:hover { transform: translateY(-4px); box-shadow: 0 6px 16px rgba(0,0,0,0.12); }
        .cover-container { position: relative; width: 100%; aspect-ratio: 1 / 1; overflow: hidden; background: #f8f9fa; }
        .cover-container img { width: 100%; height: 100%; object-fit: contain; display: block; }
        .buy-btn { position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); background-color: #6bbe23; color: white; border: none; padding: 8px 20px; border-radius: 30px; cursor: pointer; font-weight: bold; box-shadow: 0 2px 8px rgba(0,0,0,0.3); z-index: 2; }
        .book-content { padding: 15px; flex: 1; display: flex; flex-direction: column; }
        .book-content h1 { margin: 0 0 8px; font-size: 1.25rem; line-height: 1.4; color: #222; }
        .book-content p { margin: 0 0 10px; color: #555; font-size: 0.95rem; flex: 1; }
        .book-content span { font-weight: bold; color: #e63946; font-size: 1.1rem; margin-top: auto; }
        .actions { display: flex; gap: 10px; margin-top: 12px; align-items: center; flex-wrap: wrap; }
        .delete { background: #ff4d4d; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; }
        .update { background: #4da6ff; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; }
        .detail-btn { background: #1976d2; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; text-decoration: none; text-align: center; }
        .more-info { background: #eee; border: 1px solid #ccc; padding: 6px 12px; border-radius: 4px; cursor: pointer; }
        @media (max-width: 600px) { .books { grid-template-columns: 1fr; } .book { width: 100%; max-width: 420px; } }
      `}</style>
    </div>
  );
};

export default Books;